module.exports = __webpack_public_path__ + "img/16.b1971108.webp";